var render = function render(){var _vm=this,_c=_vm._self._c;return _c('strong',{staticClass:"hidden-md-and-up order-info-title",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.title))}})
}
var staticRenderFns = []

export { render, staticRenderFns }